(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-provider-card/assets/javascripts/casino-provider-card.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-provider-card/assets/javascripts/casino-provider-card.js');

'use strict';

const {
  Image
} = svs.content.image_v2;
const {
  Link
} = ReactRouterDOM;
const {
  useMemo
} = React;
const {
  dispatchGameToLastSearched
} = svs.components.casino_react.casinoStore.utils.lastSearched;
const {
  CardType
} = svs.components.casino_react.common.constants;
const cmsProviderList = svs.casino_react.shared.data.cmsProviderList;
const CasinoCardFallback = svs.components.casino_react.casinoCardFallback;
const CasinoCardWrapper = svs.components.casino_react.CasinoCardWrapper;
const urlMapping = svs.core.urlMapping;
const CasinoProviderCard = _ref => {
  var _cmsProviderList$find, _cmsProviderList$find2;
  let {
    providerName
  } = _ref;
  const providerModel = (_cmsProviderList$find = (_cmsProviderList$find2 = cmsProviderList.find(provider => provider.model.systemName === providerName)) === null || _cmsProviderList$find2 === void 0 ? void 0 : _cmsProviderList$find2.model) !== null && _cmsProviderList$find !== void 0 ? _cmsProviderList$find : {};
  const imgSrc = providerModel === null || providerModel === void 0 ? void 0 : providerModel.logoImage;
  const memoizedImage = useMemo(() => React.createElement(Image, {
    image: imgSrc
  }), [imgSrc]);
  if (!(providerModel !== null && providerModel !== void 0 && providerModel.provider)) {
    return React.createElement(CasinoCardFallback, {
      subtitle: "Otillg\xE4nglig leverant\xF6r",
      title: providerName
    });
  }
  const returnUrl = window.location.pathname + window.location.search;
  const providerPath = "".concat(urlMapping.get('casinoProvider'), "/").concat(providerModel.systemName, "?returnUrl=").concat(encodeURIComponent(returnUrl));
  return React.createElement(CasinoCardWrapper, null, React.createElement(Link, {
    className: "casino-provider-card",
    onClick: () => dispatchGameToLastSearched("".concat(CardType.PROVIDER, "_").concat(providerModel.systemName)),
    title: "L\xE4s mer om ".concat(providerModel.provider),
    to: providerPath
  }, imgSrc ? memoizedImage : React.createElement("h3", {
    className: "f-content h2 fc-white casino-provider-card__title",
    "data-testid": "provider-img-fallback"
  }, providerModel.provider)));
};
setGlobal('svs.components.casino_react.casinoProviderCard.CasinoProviderCard', CasinoProviderCard);

 })(window);